"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const i18n_1 = require("./directives/i18n");
const TrimWhitespace_1 = require("./directives/TrimWhitespace");
const App_1 = require("./components/App");
vue_1.default.directive('trim-whitespace', {
    inserted: TrimWhitespace_1.trimEmptyTextNodes,
    componentUpdated: TrimWhitespace_1.trimEmptyTextNodes,
});
vue_1.default.directive('i18n', {
    inserted: i18n_1.translateTextNode,
    componentUpdated: i18n_1.translateTextNode,
});
new vue_1.default(App_1.mainAppSettings);
//# sourceMappingURL=script.js.map